import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import voteDataReducer from "./services/votedata/reducer";
import locationReducer from "./services/location/reducer";
import trackingMiddleware from "./services/analytics/middleware";

const reducer = combineReducers({
  votedata: voteDataReducer,
  location: locationReducer
});

export default state =>
  createStore(
    reducer,
    state,
    composeWithDevTools(applyMiddleware(thunk, trackingMiddleware))
  );



// WEBPACK FOOTER //
// ./src/store.js